<app-toolbar />
<router-outlet />
<app-footer />
